import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { LabourerContext } from '../../contexts/LabourerContext';
import Modal from '../Modal';
import Loader from '../Loader';
import ButtonLoader from '../ButtonLoader';
import UploadDocumentForm from '../UploadDocumentForm';

import documentService from '../../services/documentService';

import useDocuments from '../../hooks/useDocuments';
import useDocumentTypes from '../../hooks/useDocumentTypes';

import { CheckBadgeIcon } from '@heroicons/react/20/solid';

const RequiredDocuments = ({ isLoading, onSubmit }) => {
  const { labourer } = useContext(LabourerContext);

  const [selectedDocumentType, setSelectedDocumentType] = useState(null);

  const [isUploadDocumentModalOpen, setIsUploadDocumentModalOpen] = useState(false);
  const [isUploadingDocument, setIsUploadingDocument] = useState(false);

  const { data: documentTypesData, isLoading: isLoadingDocumentTypes } = useDocumentTypes({
    page: 1,
    perPage: 1000
  });

  const documentTypes = documentTypesData?.documentTypes;

  const { data, mutate } = useDocuments({ labourerId: labourer._id, page: 1, perPage: 1000 });

  const documents = data?.documents;

  const handleUploadDocument = async (documentData) => {
    if (isUploadingDocument) return;

    documentData.labourer = labourer._id;

    try {
      setIsUploadingDocument(true);

      await documentService.createDocument({ documentData });
      await mutate();

      setIsUploadDocumentModalOpen(false);

      toast.success('Document uploaded');
    } catch (error) {
      console.log(error);
      toast.error('An error occurred while uploading the license');
    } finally {
      setIsUploadingDocument(false);
    }
  };

  const handleUploadDocumentClicked = (type) => {
    setSelectedDocumentType(type);
    setIsUploadDocumentModalOpen(true);
  }

  const handleSubmit = () => {
    onSubmit();
  }

  return (
    <>
      <p className='text-lg text-center mb-4'>
        Please upload all your relevant work documents.
      </p>

      {isLoadingDocumentTypes ? (
        <div className='py-8 flex items-center justify-center'>
          <Loader />
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-4 mb-4">
            {documentTypes?.map(documentType => (
              <div key={`document-${documentType._id}`} className='flex items-center justify-between border border-gray-300 rounded-md px-4 py-2'>
                <div className='flex flex-col gap-2 '>
                  <div className='flex items-center'>
                    <div className='flex items-center gap-2'>
                      <p className='font-medium'>{documentType.name}</p>
                    </div>
                  </div>
                </div>

                <button
                  onClick={e => handleUploadDocumentClicked(documentType)}
                  className={`text-white bg-ase-blue font-medium text-sm px-4 py-2 rounded-md w-[80px] flex items-center justify-center ${documents?.find(d => d.type._id === documentType._id) ? 'bg-green-400 text-white' : ''}`}
                >
                  {documents?.find(d => d.type._id === documentType._id) ? <CheckBadgeIcon className='h-5 w-5' /> : 'Upload'}
                </button>
              </div>
            ))}
          </div>

          <div className='flex gap-2'>
            <button
              onClick={handleSubmit}
              className='bg-ase-blue h-[48px] px-4 font-semibold text-white rounded-md flex items-center justify-center'
            >
              {isLoading ? <ButtonLoader /> : 'Finish'}
            </button>
          </div>
        </>
      )}

      <Modal
        isOpen={isUploadDocumentModalOpen}
        onClose={e => setIsUploadDocumentModalOpen(false)}
        overflowType='visible'
      >
        <UploadDocumentForm
          documentType={selectedDocumentType}
          isUploading={isUploadingDocument}
          onSubmit={handleUploadDocument}
          onCloseClicked={e => setIsUploadDocumentModalOpen(false)}
        />
      </Modal>
    </>
  );
}

export default RequiredDocuments;
